import { render, staticRenderFns } from "./SendBySegment.vue?vue&type=template&id=18937cab"
import script from "./SendBySegment.vue?vue&type=script&lang=js"
export * from "./SendBySegment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports